module.exports = __webpack_public_path__ + "static/img/RAOK-1P-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-1P-G_1.png
// module id = 6zjo
// module chunks = 0